import { render, staticRenderFns } from "./xiaofu.vue?vue&type=template&id=d3a475b8&scoped=true&"
import script from "./xiaofu.vue?vue&type=script&lang=js&"
export * from "./xiaofu.vue?vue&type=script&lang=js&"
import style0 from "./xiaofu.vue?vue&type=style&index=0&id=d3a475b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a475b8",
  null
  
)

export default component.exports